import ice from '@/sui/tools/ice'

function buildFilter (l) {
  const count = l.length
  if (count === 0) {
    return ''
  }

  let result = `$f~^${l[0]}`
  for (let i = 1; i !== count; ++i) {
    result += `|^${l[i]}`
  }
  return result
}

export const regions = ice.freeze(
  {
    ara: {
      name: 'Auvergne Rhône-Alpes',
      finess: ['01', '03', '07', '15', '26', '38', '42', '43', '63', '69', '73', '74']
    },

    bourgognefc: {
      name: 'Bourgogne Franche Comté',
      finess: ['21', '25', '39', '58', '70', '71', '89', '90']
    },

    bretagne: {
      name: 'Bretagne',
      finess: ['22', '29', '35', '56']
    },

    cvl: {
      name: 'Centre-Val de Loire',
      finess: ['18', '28', '36', '37', '41', '45']
    },

    corse: {
      name: 'Corse',
      finess: ['2A', '2B']
    },

    grandest: {
      name: 'Grand Est',
      finess: ['08', '10', '51', '52', '54', '55', '57', '67', '68', '88']
    },

    guadeloupe: {
      name: 'Guadeloupe',
      finess: ['9701']
    },

    guyane: {
      name: 'Guyane',
      finess: ['9703']
    },

    hdf: {
      name: 'Hauts-de-France',
      finess: ['02', '59', '60', '62', '80']
    },

    idf: {
      name: 'Île-de-France',
      finess: ['75', '77', '78', '91', '92', '93', '94', '95']
    },

    reunionmayotte: {
      name: 'Réunion-Mayotte',
      finess: ['9704', '98']
    },

    martinique: {
      name: 'Martinique',
      finess: ['9702']
    },

    normandie: {
      name: 'Normandie',
      finess: ['14', '27', '50', '61', '76']
    },

    nouvelleaq:
    {
      name: 'Nouvelle-Aquitaine',
      finess: [
        '16', '17', '19', '23', '24', '33', '40', '47', '64', '79', '86', '87'
      ]
    },

    occitanie: {
      name: 'Occitanie',
      finess: [
        '09', '11', '12', '30', '31', '32', '34', '46', '48',
        '65', '66', '81', '82'
      ]
    },

    pdl: {
      name: 'Pays de la Loire',
      finess: ['44', '49', '53', '72', '85']
    },

    paca: {
      name: `Provence-Alpes-Côte-d'Azur`,
      finess: ['04', '05', '06', '13', '83', '84']
    },

    hf: {
      name: 'Hors France',
      finess: ['HF']
    }
  }
)

export const filters = ice.freeze(
  [
    {
      name: regions.ara.name,
      filter: buildFilter(regions.ara.finess)
    },
    {
      name: regions.bourgognefc.name,
      filter: buildFilter(regions.bourgognefc.finess)
    },
    {
      name: regions.bretagne.name,
      filter: buildFilter(regions.bretagne.finess)
    },
    {
      name: regions.cvl.name,
      filter: buildFilter(regions.cvl.finess)
    },
    {
      name: regions.corse.name,
      filter: buildFilter(regions.corse.finess)
    },
    {
      name: regions.grandest.name,
      filter: buildFilter(regions.grandest.finess)
    },
    {
      name: regions.guadeloupe.name,
      filter: buildFilter(regions.guadeloupe.finess)
    },
    {
      name: regions.guyane.name,
      filter: buildFilter(regions.guyane.finess)
    },
    {
      name: regions.hdf.name,
      filter: buildFilter(regions.hdf.finess)
    },
    {
      name: regions.idf.name,
      filter: buildFilter(regions.idf.finess)
    },
    {
      name: regions.reunionmayotte.name,
      filter: buildFilter(regions.reunionmayotte.finess)
    },
    {
      name: regions.martinique.name,
      filter: buildFilter(regions.martinique.finess)
    },
    {
      name: regions.normandie.name,
      filter: buildFilter(regions.normandie.finess)
    },
    {
      name: regions.nouvelleaq.name,
      filter: buildFilter(regions.nouvelleaq.finess)
    },
    {
      name: regions.occitanie.name,
      filter: buildFilter(regions.occitanie.finess)
    },
    {
      name: regions.pdl.name,
      filter: buildFilter(regions.pdl.finess)
    },
    {
      name: regions.paca.name,
      filter: buildFilter(regions.paca.finess)
    },
    {
      name: regions.hf.name,
      filter: buildFilter(regions.hf.finess)
    }
  ]
)

export function indexOf (finess) {
  let t = 0
  for (let i in regions) {
    const region = regions[i]
    const re = new RegExp(`^${region.finess.join('|^')}`, 'i')
    if (re.test(finess)) {
      return t
    }
    ++t
  }

  return -1
}

export function getRegion (finess) {
  const index = indexOf(finess)
  if (index === -1) {
    return null
  }

  return filters[index]
}

export default {
  regions: regions,
  filters: filters,
  indexOf: indexOf,
  getRegion: getRegion
}
